import { toFormatCurrency } from './format';
import { isNumeric } from './market-development';
import { isAdmin } from './role';

const EWSTypeStatement = {
	q1: 'Quarter1',
	q2: 'Quarter2',
	q3: 'Quarter3',
	q4: 'Quarter4',
	aa: 'AnnualAudited',
	an: 'AnnualNonAudited',
};

const EWSTypeTemplate = {
	SFP: 'SFP',
	SPLOCI: 'SPLOCI',
	SCF: 'SCF',
	SOCE: 'SOCE',
	ORD: 'ORD',
	IR: 'IR',
};

const EWSRatioTypeTemplate = {
	L: 'Life',
	NL: 'NonLife',
	GR: 'GroupingRisk',
	GRB: 'GroupingRiskBased',
	CRR: 'CompanyRiskRanking',
};

const EWSTypeCurrency = {
	KHR: 'KHR',
	USD: 'USD',
};

const EWSSoceTypeColumn = {
	ShareCapital: 'scap',
	SharePremium: 'sprm',
	DepositsForFuterShareSubscription: 'dfss',
	RevaluationReserves: 'rrsv',
	RetainedEarningsAccumulatedLoses: 'real',
	OtherComponentsOfEquity: 'oceq',
};

function sumOrError(values) {
	if (values?.map((value) => isNumeric(value))?.includes(false)) {
		return 'Error';
	} else {
		return values?.reduce((pre, cur, i) => pre + cur, 0);
	}
}

function percent(a, b) {
	if (isNumeric(a) && isNumeric(b) && parseFloat(b) !== 0) {
		return Math.round(parseFloat(a / b) * 100) + '%';
	} else {
		return toFormatCurrency(0, null) + '%';
	}
}

function filterOptions({ user, industrial }) {
	const options = [
		{ label: industrial === true ? 'Total Industry' : 'Total Ews', value: '1' },
		{ label: 'General Insurance', value: '2' },
		{ label: 'Life Insurance', value: '3' },
		{ label: 'Micro Insurance', value: '4' },
	];

	if (isAdmin(user?.role)) {
		options?.push({ label: 'ReInsurance', value: '5' });
	}

	return options;
}

const permissions = [
	'ewsCanViewStatementGeneralInsurance',
	'ewsCanViewStatementLifeInsurance',
	'ewsCanViewStatementMicroInsurance',
	'ewsCanViewStatementReinsurance',
];

function getFilterOptions({ industrial = false, user = null }) {
	if (!user) return [];
	if (industrial || isAdmin(user?.role)) return [...filterOptions({ user, industrial })];

	const list = [];
	if (user?.ews?.includes('ewsCanViewStatementGeneralInsurance')) {
		list.push({ label: 'General Insurance', value: '2' });
	}
	if (user?.ews?.includes('ewsCanViewStatementLifeInsurance')) {
		list.push({ label: 'Life Insurance', value: '3' });
	}
	if (user?.ews?.includes('ewsCanViewStatementMicroInsurance')) {
		list.push({ label: 'Micro Insurance', value: '4' });
	}
	if (user?.ews?.includes('ewsCanViewStatementReinsurance')) {
		list.push({ label: 'ReInsurance', value: '5' });
	}

	return permissions?.every((e) => user?.ews?.includes(e)) ? [...filterOptions({ user, industrial })] : [...list];
}

function getDefaultFilterOption({ filterOptions = [] }) {
	return filterOptions?.length > 0 ? filterOptions?.sort((a, b) => (parseInt(a?.value) > parseInt(b?.value) ? 1 : -1))[0] : null;
}

function getDefaultFilterOptionValue({ filterOptions = [] }) {
	const filterOption = getDefaultFilterOption({ filterOptions });
	return filterOption ? filterOption?.value : '';
}

function getCompanyTypesByFilterOptionValue(value) {
	if (value === '1') {
		return ['GENERAL_INSURANCE', 'LIFE_INSURANCE', 'MICRO_INSURANCE'];
	} else if (value === '2') {
		return ['GENERAL_INSURANCE'];
	} else if (value === '3') {
		return ['LIFE_INSURANCE'];
	} else if (value === '4') {
		return ['MICRO_INSURANCE'];
	} else if (value === '5') {
		return ['REINSURANCE'];
	}
	return [];
}

export {
	EWSTypeStatement,
	EWSTypeCurrency,
	EWSTypeTemplate,
	EWSRatioTypeTemplate,
	EWSSoceTypeColumn,
	sumOrError,
	percent,
	getFilterOptions,
	getDefaultFilterOption,
	getDefaultFilterOptionValue,
	getCompanyTypesByFilterOptionValue,
};
